import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer"
import bannerImage from "../../Images/Banner/banner-5.webp"
import sportsIntroImg from "../../Images/sports/sports-1.webp";
import sport1 from "../../Images/sports/sports-1.webp";
import sport2 from "../../Images/sports/sports-2.webp";
import sport3 from "../../Images/sports/sports-3.webp";
import sport4 from "../../Images/sports/sports-4.webp";
import sport5 from "../../Images/sports/sports-5.webp";
import sport6 from "../../Images/sports/sports-6.webp";
import sport7 from "../../Images/sports/sports-7.webp";
import sport8 from "../../Images/sports/sports-8.webp";
import "../../home.css";
const Sports = () => {

    const sportsFacilities = [
        {
            iconClass: "ti ti-ball-football",
            title: "Green Football Arena",
            description: "A full-sized, well-maintained ground ideal for tournaments and rigorous practice sessions."
        },
        {
            iconClass: "ti ti-ball-basketball",
            title: "Advanced Basketball Court",
            description: "Synthetic surface with high-performance flooring and lighting for all-day play.."
        },
        {
            iconClass: "ti ti-run",
            title: "Pro-Grade Running Track",
            description: "400m international-standard track designed for sprinters and endurance athletes"
        },
        {
            iconClass: "ti ti-trophy",
            title: "Recognition & Rewards",
            description: "Consistent achievers in sports are honored with awards at national and international events."
        },
    ];

    return (
        <React.Fragment>
            <title>Sports Facilities at ISBM University – Complete Infrastructure</title>
            <meta
                name="description"
                content="ISBM University sports facilities provide venues, equipment & space for games, fitness & wellness, helping students balance academics & athletic life."
            />
            <Topnav />
            <section className="section-hero-banner ptb-50" style={{
                backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
            }}>
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Empowering Sports Spirit</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Sports
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sports Intro */}
            <section className="sports-intro-section ptb-50">
                <div className="container-xxl">
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="sports-intro-content">
                                <h2 className="modern-title text-blue">Developing Champions On and Off the Field</h2>
                                <p>
                                    At ISBM University, we recognize that education goes beyond textbooks and classrooms — it’s about nurturing well-rounded individuals. Our commitment to sports is rooted in the belief that physical development, teamwork, and discipline are integral to holistic learning. We offer students access to modern sports infrastructure and a diverse range of sporting disciplines guided by experienced professional coaches. Whether it’s training on the field or competing in tournaments, our students are constantly encouraged to strive for excellence, build resilience, and foster leadership through sport. The sports culture at ISBM University is vibrant and inclusive, promoting fitness, fair play, and camaraderie across the student community. We take pride in creating an environment where future leaders are shaped not only by their academic achievements but also by the values and skills instilled through active participation in sports.
                                </p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="sports-intro-image">
                                <img src={sportsIntroImg} alt="ISBM Sports Facilities" className="img-fluid rounded" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>


            {/* Sports Facilities */}
            <section className="sports-facilities-section pb-100 sports-info-section ptb-50">
                <div className="container-xxl">
                    <h2 className="section-title modern-title text-center text-white"> Enabling Excellence Through Sports Infrastructure</h2>
                    <h6 className="modern-subtitle text-center text-white">At our institute, we foster all-round development by providing state-of-the-art sports facilities that empower students to perform at their best—on the field and beyond.</h6>
                    <div className="row">
                        {sportsFacilities.map((facility, index) => (
                            <div className="col-md-3 col-sm-6 col-12 mb-3 d-flex">
                                <div key={index} className="sports-facility-card m-auto h-100 w-100">
                                    <div className="facility-icon">
                                        <i className={`${facility.iconClass} facility-icon-style`}></i>
                                    </div>
                                    <h3 className="facility-title">{facility.title}</h3>
                                    <p className="facility-description">{facility.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="sports-collage-galler ptb-50">
                <div className="container-xxl">
                    <h2 className="section-title modern-title text-center text-blue">Sports Gallery</h2>
                    <p className="modern-subtitle text-center text-blue">Capturing the Spirit of Athletic Excellence</p>
                    {/* First Row */}
                    <Row className="gallery-row align-items-stretch">
                        {/* Left side - 4 images in 2x2 grid */}
                        <Col lg={6} className="gallery-col pe-lg-3">
                            <Row className="gallery-inner-row g-3">
                                <Col xs={6} className="gallery-inner-col">
                                    <div className="collage-item small-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport1} alt="Tennis Playground" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>Tennis Playground</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6} className="gallery-inner-col">
                                    <div className="collage-item small-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport2} alt="Kabaddi Team" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>our Men’s Kabaddi team leads with passion and pride.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6} className="gallery-inner-col">
                                    <div className="collage-item small-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport3} alt="Athletics Meet" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>Athletics Meet</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={6} className="gallery-inner-col">
                                    <div className="collage-item small-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport4} alt="Swimming Pool" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>Swimming Pool</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        {/* Right side - 1 big image */}
                        <Col lg={6} className="gallery-col ps-lg-3">
                            <div className="collage-item large-item h-100">
                                <div className="gallery-image-wrapper">
                                    <img src={sport5} alt="Cricket Academy" className="gallery-image" />
                                    <div className="image-overlay">
                                        <div className="overlay-content">
                                            <h3>Cricket Academy</h3>
                                            <p>Professional coaching sessions</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Second Row */}
                    <Row className="gallery-row align-items-stretch">
                        {/* Left side - 1 medium image */}
                        <Col lg={6} className="gallery-col pe-lg-3">
                            <div className="collage-item medium-item h-100">
                                <div className="gallery-image-wrapper">
                                    <img src={sport6} alt="Women's Sports Excellence" className="gallery-image" />
                                    <div className="image-overlay">
                                        <div className="overlay-content">
                                            <h3>Women's Sporting Excellence</h3>
                                            <p>Annual championship event</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Right side - 2 small images in row */}
                        <Col lg={6} className="gallery-col ps-lg-3">
                            <Row className="h-100 g-3">
                                <Col md={6} className="h-100">
                                    <div className="collage-item xsmall-item h-100">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport7} alt="football Team" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>Global Competition</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6} className="h-100">
                                    <div className="collage-item xsmall-item h-100">
                                        <div className="gallery-image-wrapper">
                                            <img src={sport8} alt="Carrom Athletics" className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <p>Veteran Carrom Strategist</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section>

            <Footer />
        </React.Fragment>
    );
};

export default Sports;
